module.exports = __webpack_public_path__ + "static/media/sdk-0.8ef05d68.svg";